'use client'

import moduleMap from '../../../constants/moduleMap'
import { ApiPagePage } from '../../../types/contentTypes'

const ModulesList = ({
  landingContentData,
  medallistData
}: {
  landingContentData: ApiPagePage['attributes']
  medallistData: any
}) => {
  return landingContentData?.modules?.map((content: any, index: number) => {
    const Module = moduleMap[content.__component as keyof typeof moduleMap] || moduleMap['DefaultModule']
    const moduleSpecificProps = content.__component === 'awards-module.medallist' ? { medallistData } : {}
    return (
      <Module
        key={index}
        moduleProps={content}
        landingContentData={landingContentData}
        moduleSpecificProps={moduleSpecificProps}
      />
    )
  })
}

export default ModulesList
